import { jsxs as r, jsx as l } from "react/jsx-runtime";
const h = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m44.095 39.608-.637-.516-.63.525c-.539.449-5.263 4.484-5.263 7.95 0 3.736 3.452 5.416 5.902 5.416 1.351 0 2.73-.434 3.784-1.194 1.385-.997 2.117-2.458 2.117-4.222 0-3.582-4.733-7.521-5.272-7.959Zm1.988 10.56c-.71.512-1.688.816-2.616.816-1.51 0-3.904-.928-3.904-3.418 0-1.693 2.187-4.27 3.907-5.855.451.41 1.087 1.023 1.716 1.74 1.408 1.608 2.184 3.07 2.184 4.115 0 1.111-.433 1.986-1.287 2.601v.001Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M32 6.001c-10.017 0-18.167 8.15-18.167 18.167v30.808h-2.894v2.997h19.458v-2.997h-3.33V24.168a4.937 4.937 0 0 1 4.931-4.931 4.937 4.937 0 0 1 4.932 4.931v7.434h13.235v-7.434c0-10.017-8.15-18.167-18.166-18.167Zm14.17 21.605h-5.243v-3.438c0-4.922-4.005-8.927-8.927-8.927-4.923 0-8.928 4.005-8.928 8.927v30.808h-5.244V24.168c0-7.814 6.357-14.171 14.172-14.171 7.814 0 14.17 6.357 14.17 14.171v3.438Z"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M50.06 33.354H36.83v2.997h13.23v-2.997Z" })
    ]
  }
);
export {
  h as TapsAndToilets
};
